import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8" data-testid="terms-heading">Terms of Service</h1>
          <Card>
            <CardContent className="p-8 prose prose-gray max-w-none">
              <p className="text-sm text-gray-500 mb-6">Last Updated: January 2025</p>
              
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using Yalla ! Lets Save. ("the Service", "we", "us", or "our"), you accept and agree to be bound by these Terms of Service.
              </p>

              <h2>2. Use of Service</h2>
              <p>You agree to:</p>
              <ul>
                <li>Provide accurate information when creating an account</li>
                <li>Not misuse or abuse the deals or our platform</li>
                <li>Not attempt to scrape, copy, or duplicate our content</li>
                <li>Respect merchant terms when redeeming deals</li>
              </ul>

              <h2>3. Deals and Offers</h2>
              <ul>
                <li>All deals are subject to merchant availability and terms</li>
                <li>We strive to verify all deals but cannot guarantee 100% accuracy</li>
                <li>Deals may expire or be modified without notice</li>
                <li>Merchants are solely responsible for honoring their advertised deals</li>
              </ul>

              <h2>4. User Accounts</h2>
              <p>
                You are responsible for maintaining the security of your account. We reserve the right to suspend or terminate accounts that violate these terms.
              </p>

              <h2>5. Intellectual Property</h2>
              <p>
                All content on Yalla ! Lets Save., including logos, text, graphics, and software, is our property or licensed to us and protected by UAE and international copyright laws.
              </p>

              <h2>6. Disclaimer</h2>
              <p>
                The Service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted service or error-free operation.
              </p>

              <h2>7. Limitation of Liability</h2>
              <p>
                We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the Service or inability to redeem deals.
              </p>

              <h2>8. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Yalla ! Lets Save. from any claims arising from your use of the Service or violation of these terms.
              </p>

              <h2>9. Modifications</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance of new terms.
              </p>

              <h2>10. Governing Law</h2>
              <p>
                These terms are governed by the laws of the United Arab Emirates. Any disputes shall be resolved in UAE courts.
              </p>

              <h2>11. Contact</h2>
              <p>
                For questions about these Terms, contact us at: <a href="mailto:legal@yallasavings.com" className="text-emerald-600">legal@yallasavings.com</a>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};